import { useMemo } from 'react'
import formatISO from 'date-fns/formatISO/index.js'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'message',
    path: 'params.patient_id',
  })
  let default_payment_account_id = useDataValue({
    viewPath: props.viewPath,
    context: 'message',
    path: 'params.payer_account_id',
  })

  return useMemo(
    () => ({
      ...data,
      patient_id,
      default_payment_account_id,
      due_date: formatISO(new Date()),
      charges: [
        {
          id: crypto.randomUUID(),
          type_id: null,
          name: '',
          amount: 0,
          is_included_in_insurance_claim: true,
          requires_tooth_details: false,
        },
      ],
    }),
    [data, default_payment_account_id, patient_id]
  )
}
